const CircleCloseIcon = (): JSX.Element => {
  return (
    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.92893 24.0413C13.8342 27.9466 20.1658 27.9466 24.0711 24.0413C27.9763 20.1361 27.9763 13.8044 24.0711 9.89919C20.1658 5.99395 13.8342 5.99395 9.92893 9.89919C6.02369 13.8044 6.02369 20.1361 9.92893 24.0413Z"
        stroke="#8083A0"
        strokeWidth="1.5"
      />
      <rect
        x="20.0535"
        y="12.9531"
        width="1.36364"
        height="10"
        rx="0.681818"
        transform="rotate(45 20.0535 12.9531)"
        fill="#8083A0"
      />
      <rect
        x="21.0177"
        y="20.0234"
        width="1.36364"
        height="10"
        rx="0.681818"
        transform="rotate(135 21.0177 20.0234)"
        fill="#8083A0"
      />
    </svg>
  );
};

export default CircleCloseIcon;
